// import React from "react";
// import {
//   Box,
//   Container,
//   Divider,
//   Grid,
//   IconButton,
//   Link as MLink,
//   List,
//   ListItem,
//   ListItemText,
//   Stack,
//   Typography,
// } from "@mui/material";

// const services = [
//   "Web Design",
//   "Video Production",
//   "Digital Marketing",
//   "Web Development",
//   "UI/UX Design",
// ];
// const company = [
//   "About",
//   "Services",
//   "Portfolios",
//   "Blogs",
//   "Contact",
//   "Licenses",
// ];

// export default function Footer() {
//   return (
//     <Box
//       component="footer"
//       sx={{
//         bgcolor: "#0b0b09ff",
//         color: "grey.300",
//         pt: { xs: 8, md: 10 },
//         pb: { xs: 4, md: 6 },
//         pl:12,
//         pr:4
//       }}
//     >
//       <Box>
//         <Grid container spacing={6}  justifyContent="flex-end">
//           <Grid item xs={12} md={8} lg={9}>
//             <Grid container spacing={4}>
//               <Grid item xs={12} sm={6} md={4}>
//                 <Typography
//                   variant="h6"
//                   sx={{ color: "common.white", mb: 2, letterSpacing: 0.5 }}
//                 >
//                   SERVICE
//                 </Typography>
//                 <List dense disablePadding>
//                   {services.map((s) => (
//                     <ListItem key={s} disableGutters sx={{ py: 0.5 }}>
//                       <ListItemText
//                         primaryTypographyProps={{
//                           color: "#A1A1A1",
//                           sx: { "&:hover": { color: "grey.200" } },
//                         }}
//                         primary={s}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Grid>

//               <Grid item xs={12} sm={6} md={4}>
//                 <Typography
//                   variant="h6"
//                   sx={{ color: "common.white", mb: 2, letterSpacing: 0.5 }}
//                 >
//                   COMPANY
//                 </Typography>
//                 <List dense disablePadding>
//                   {company.map((s) => (
//                     <ListItem key={s} disableGutters sx={{ py: 0.5 }}>
//                       <ListItemText
//                         primaryTypographyProps={{
//                           color: "#A1A1A1",
//                           sx: { "&:hover": { color: "grey.200" } },
//                         }}
//                         primary={s}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Grid>

//               <Grid item xs={12} sm={12} md={4}>
//                 <Typography
//                   variant="h6"
//                   sx={{ color: "common.white", mb: 2, letterSpacing: 0.5 }}
//                 >
//                   ADDRESS
//                 </Typography>
//                 <Stack spacing={1.2} sx={{ color: "#A1A1A1" }}>
//                   <MLink href="#" underline="hover" color="inherit">
//                     Dha Phase 5, Lahore
//                   </MLink>
//                   <Typography variant="body2">+1 287-360-633</Typography>
//                   <MLink
//                     href="mailto:info@metdot.com"
//                     underline="hover"
//                     color="inherit"
//                   >
//                     Info@Metdot.Com
//                   </MLink>
//                 </Stack>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>

//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             flexWrap: "wrap",
//             gap: 3,
//           }}
//         >
//           {/* LEFT: Logo */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: { xs: "center", md: "flex-start" },
//               flex: { xs: "1 1 100%", md: "0 0 auto" },
//             }}
//           >
//             <img
//               src="/assets/footer/footerLogo.png"
//               alt="Logo"
//               style={{ width: "100%", height: "auto" }}
//             />
//           </Box>

//           {/* CENTER: Divider + Arrow button */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flex: { xs: "1 1 100%", md: "1 1 auto" },
//             }}
//           >
//             <Stack
//               direction="row"
//               alignItems="center"
//               spacing={2}
//               sx={{ width: "100%", maxWidth: 500 }}
//             >
//               <Divider sx={{ flex: 1, borderColor: "#23261D" }} />
//               <IconButton
//                 aria-label="Back to top"
//                 onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//                 size="large"
//                 sx={{
//                   border: "1px solid ",
//                   borderRadius: "60px",
//                   width: "50px",
//                   height: "60px",
//                   borderColor: "#23261D",
//                   color: "primary.main",
//                   "&:hover": { bgcolor: "rgba(255,255,255,0.04)" },
//                 }}
//               >
//                 {/* <ArrowUpwardIcon /> */}

//                 <img
//                   src="/assets/footer/farrow.png"
//                   alt="Phone"
//                   style={{ width: 20, height: 20 }}
//                 />
//               </IconButton>
//               <Divider sx={{ flex: 1, borderColor: "#23261D" }} />
//             </Stack>
//           </Box>

//           {/* RIGHT: Links */}
//           <Stack
//             direction="row"
//             justifyContent={{ xs: "center", md: "flex-end" }}
//             alignItems="center"
//             spacing={2}
//             sx={{
//               flex: { xs: "1 1 100%", md: "0 0 auto" },
//             }}
//           >
//             <MLink href="#" underline="hover" color="#A1A1A1">
//               Facebook
//             </MLink>
//             <Typography component="span" sx={{ color: "#535848" }}>
//               |
//             </Typography>
//             <MLink href="#" underline="hover" color="#A1A1A1">
//               LinkedIn
//             </MLink>
//             <Typography component="span" sx={{ color: "#535848" }}>
//               |
//             </Typography>
//             <MLink href="#" underline="hover" color="#A1A1A1">
//               Dribbble
//             </MLink>
//           </Stack>
//         </Box>
//       </Box>
//     </Box>
//   );
// }



import React from "react";
import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  Link as MLink,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

const services = [
  "Web design & UI",
  "Social media visuals",
  "Infographics",
  "Design system",
  "Email design",
  "Stationery",
  "Icons",
  "Packaging & merch",
  "Signage",
  "Brochures",
  "Logos & branding",
  "Digital ads",
  "Wireframes",

];
const company = [
  "About",
  "Services",
  "Portfolios",
  "Blogs",
  "Contact",
  "Licenses",
];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#0b0b09ff",
        color: "grey.300",
        pt: { xs: 6, md: 10 },
        pb: { xs: 4, md: 6 },
        px: { xs: 3, sm: 6, md: 10 },
      }}
    >
      <Box>
        {/* Top Section */}
        <Grid container spacing={6} justifyContent={{ xs: "center", md: "flex-end" }}>
          <Grid item xs={12} md={8} lg={9}>
            <Grid container spacing={4}>


              {/* COMPANY */}
              <Grid item xs={12} sm={6} md={3}>
                {/* <Typography
                  variant="h6"
                  sx={{
                    color: "common.white",
                    mb: 2,
                    letterSpacing: 0.5,
                    textAlign: { xs: "left", sm: "left" },
                  }}
                >
                  COMPANY
                </Typography>
                <List dense disablePadding sx={{ textAlign: { xs: "left", sm: "left" } }}>
                  {company.map((s) => (
                    <ListItem key={s} disableGutters sx={{ py: 0.5, justifyContent: { xs: "center", sm: "flex-start" } }}>
                      <ListItemText
                        primaryTypographyProps={{
                          color: "#A1A1A1",
                          sx: { "&:hover": { color: "grey.200" } },
                        }}
                        primary={s}
                      />
                    </ListItem>
                  ))}
                </List> */}
              </Grid>
              {/* SERVICES */}
              {/* <Grid item xs={12} sm={6} md={4}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "common.white",
                    mb: 2,
                    letterSpacing: 0.5,
                    textAlign: { xs: "left", sm: "left" },
                  }}
                >
                  SERVICE
                </Typography>
                <List dense disablePadding sx={{ textAlign: { xs: "left", sm: "left" } }}>
                  {services.map((s) => (
                    <ListItem key={s} disableGutters sx={{ py: 0.5, justifyContent: { xs: "center", sm: "flex-start" } }}>
                      <ListItemText
                        primaryTypographyProps={{
                          color: "#A1A1A1",
                          sx: { "&:hover": { color: "grey.200" } },
                        }}
                        primary={s}
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid> */}


              <Grid item xs={12} sm={6} md={5}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "common.white",
                    mb: 2,
                    letterSpacing: 0.5,
                    textAlign: { xs: "left", sm: "left" },
                  }}
                >
                  SERVICE
                </Typography>

                <Box sx={{ display: "flex", gap: 4 }}>
                  {/* Split services into two halves */}
                  {[services.slice(0, Math.ceil(services.length / 2)), services.slice(Math.ceil(services.length / 2))].map((half, index) => (
                    <List key={index} dense disablePadding sx={{ textAlign: { xs: "left", sm: "left" } }}>
                      {half.map((s) => (
                        <ListItem key={s} disableGutters sx={{ py: 0.5 }}>
                          <ListItemText
                            primaryTypographyProps={{
                              color: "#A1A1A1",
                              sx: { "&:hover": { color: "grey.200" } },
                            }}
                            primary={s}
                          />
                        </ListItem>
                      ))}
                    </List>
                  ))}
                </Box>
              </Grid>


              {/* ADDRESS */}
              <Grid item xs={12} sm={12} md={4}>
                <Typography
                  variant="h6"
                  sx={{
                    color: "common.white",
                    mb: 2,
                    letterSpacing: 0.5,
                    textAlign: { xs: "left", sm: "left" },
                  }}
                >
                  ADDRESS
                </Typography>
                <Stack
                  spacing={1.2}
                  sx={{
                    color: "#A1A1A1",
                    textAlign: { xs: "left", sm: "left" },
                  }}
                >
                  <MLink href="#" underline="hover" color="inherit">
                    DHA Phase 5, Lahore
                  </MLink>
                   <MLink href="#"  color="inherit">
                    +92 302 5550221
                  </MLink>
                  
                  <MLink href="mailto:info@metdot.com" underline="hover" color="inherit">
                    info@metdot.com
                  </MLink>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Divider + Logo + Links */}
        <Box
          sx={{
            mt: { xs: 6, md: 8 },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: { xs: 4, sm: 3 },
          }}
        >
          {/* LEFT: Logo */}
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              flex: { xs: "1 1 100%", md: "0 0 auto" },
            }}
          >
            {/* <img
              src="/assets/footer/footerLogo.png"
              alt="Logo"
              style={{ width: {xs: "130px", md: "100%"} ,height: "auto" }}
            /> */}

            <Box
              component="img"
              src="/assets/footer/footerLogo.png"
              alt="Logo"
              sx={{
                width: { xs: "130px", md: "100%" },
                height: "auto",
              }}
            />

          </Box>

          {/* CENTER: Divider + Button */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: { xs: "1 1 100%", md: "1 1 auto" },
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ width: "100%", maxWidth: 500 }}
            >
              <Divider sx={{ flex: 1, borderColor: "#23261D" }} />
              <IconButton
                aria-label="Back to top"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                size="large"
                sx={{
                  border: "1px solid",
                  borderRadius: "60px",
                  width: "50px",
                  height: "60px",
                  borderColor: "#23261D",
                  color: "primary.main",
                  "&:hover": { bgcolor: "rgba(255,255,255,0.04)" },
                }}
              >
                <img
                  src="/assets/footer/farrow.png"
                  alt="Arrow Up"
                  style={{ width: 20, height: 20 }}
                />
              </IconButton>
              <Divider sx={{ flex: 1, borderColor: "#23261D" }} />
            </Stack>
          </Box>

          {/* RIGHT: Social Links */}
          <Stack
            direction="row"
            justifyContent={{ xs: "center", md: "flex-end" }}
            alignItems="center"
            spacing={2}
            sx={{
              flex: { xs: "1 1 100%", md: "0 0 auto" },
              flexWrap: "wrap",
              textAlign: "center",
            }}
          >
            <MLink
              href="https://www.instagram.com/met_dot/"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="#A1A1A1"
            >
              Instagram
            </MLink>

            <Typography component="span" sx={{ color: "#535848" }}>
              |
            </Typography>

            <MLink
              href="https://www.linkedin.com/company/metdot"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="#A1A1A1"
            >
              LinkedIn
            </MLink>
          </Stack>

        </Box>
      </Box>
    </Box>
  );
}
